const translations = [
    {
        es: [],
        de: []
    },
    {
        es: ["- ¡Culpa mía! ¿Todos bien?", "- ¡Voy a buscar a mi mamá!"],
        de: ["- Mein Fehler! Alle in Ordnung?", "- Ich hole meine Mama!"]
    },
    {
        es: ["¡Es un imbécil!"],
        de: ["Er ist ein Arschloch!"]
    },
    {
        es: ["- ¿Cómo te llamas, chico?", "- Michel."],
        de: ["- Wie ist dein Name, Junge?", "- Michel."]
    },
    {
        es: ["- ¿Sabes quién soy?", "- ¡Mi papá dice que eres un imbécil!"],
        de: ["- Weißt du wer ich bin?", "- Mein Papa sagt, du bist ein Arschloch!"]
    },
    {
        es: ["Esa no es realmente una buena palabra para llamar a una persona, ¿verdad?"],
        de: ["Das ist nicht wirklich ein nettes Wort, eine Person so zu rufen, oder?"]
    },
    {
        es: ["- ¿Imbécil?", "- ¡Sí, porque eso podría enojar mucho a alguien!"],
        de: ["- Arschloch?", "- Ja, weil das könnte jemanden sehr wütend machen!"]
    },
    {
        es: ["- Y ya sabes, ¡quizás herir sus sentimientos!", "- ¡Te comportas como un imbécil!"],
        de: ["- Und weißt du, vielleicht seine Gefühle verletzen!", "- Du benimmst dich wie ein Arschloch!"]
    },
    {
        es: ["- Está bien, ¿conoces a Aaron?", "Sí, el pequeño imbécil?"],
        de: ["- In Ordnung, äh, (kennst du) Aaron?", "Ja, das kleine Arschloch?"]
    },
    {
        es: ["Pues, parece ser un niño bastante bueno."],
        de: ["Nun, äh, (er) scheint ein ziemlich guter Junge zu sein."]
    },
    {
        es: ["- Solo quiero pedirte que lo dejes un poco.", "- ¿Por qué imbécil?"],
        de: ["- Ich möchte dich nur bitten ihn ein bisschen in Ruhe zu lassen.", "- Warum Arschloch?"]
    },
    {
        es: ["- ¡Vas a dejar de llamarme así!", "- Imbécil!"],
        de: ["- Du wirst aufhören, mich so zu nennen!", "- Arschloch!"]
    },
    {
        es: ["- ¡Ese no es mi nombre!", "- Imbécil!"],
        de: ["- Das ist nicht mein Name!", "- Arschloch!"]
    },
    {
        es: ["¡Llámame imbécil, una vez más!"],
        de: ["Nenn mich noch einmal Arschloch!"]
    },
    {
        es: ["Imbéc..."],
        de: ["Arsch..."]
    },
    {
        es: ["¿Qué hay de ti, gordo?"],
        de: ["Was ist mit dir, Fettsack?"]
    },
    {
        es: ["¿Gafas?"],
        de: ["Brillenschlange?"]
    },
    {
        es: ["Hancock, hijo de puta, sabía que vendrías, ¡pregúntaselo a Mary!"],
        de: ["Hancock, du Gauner, ich wusste du würdest kommen, frag Mary!"]
    },
    {
        es: ["Tuve un presentimiento, dije que me escuchó, ¡está listo para un cambio!"],
        de: ["Ich hatte es im Gefühl, ich sagte mir, er hat mich gehört, er ist bereit für eine Veränderung!"]
    },
    {
        es: ["¡Esto es genial! ¿Tú hiciste esto? ¿Llegaste un poco caliente?"],
        de: ["Das ist toll! Hast du das gemacht? Bist du ein bisschen heiß reingekommen/gelandet?"]
    },
    {
        es: ["- ¡Sí, te veré en la casa!", "- Este es el lugar perfecto para que empecemos, ¡sí que no conduces!", "- ¡Ay, maldita sea!"],
        de: ["- Ja, ich treffe dich im Haus!", "- Das ist genau der richtige Ort für uns zum Anfangen, ich weiß, du fährst kein Auto!", "- Oh, verdammt!"]
    },
    {
        es: ["¡Está bien, está bien, está bien, está bien!"],
        de: ["In Ordnung, alles in Ordnung, alles in Ordnung, alles in Ordnung!"]
    },
    {
        es: ["¡Mamá, Mamá!"],
        de: ["Mama, Mama!"]
    },
    {
        es: ["Oh, deja de llorar idiota, ¡adelante!"],
        de: ["Oh, hör auf zu heulen du Kobold, vorwärts!"]
    },
    {
        es: ["- Esto no está bien, ¿de acuerdo?,", "- ¡El está bien! Él...", "- ¡Esto realmente no está bien!"],
        de: ["- Das ist nicht ok, ok?", "- Er ist ok! Er...", "- Das ist wirklich nicht ok!"]
    },
    {
        es: ["¡Estas son algunas de las cosas en las que vamos a trabajar!"],
        de: ["Das sind einige der Dinge, an denen wir arbeiten werden!"]
    },
    {
        es: ["¿Cómo crees que irá esa conversación con su mamá?"],
        de: ["Wie denkst du, wird das Gespräch mit seiner Mutter laufen?"]
    },
    {
        es: ["¡Aterrizar así en la calle también está en el lado desagradable!"],
        de: ["So auf der Straße zu landen ist auch uncool!"]
    },
    {
        es: ["¡No, eso ya era así cuando llegué aquí, Ray!"],
        de: ["Nein, das war schon so, als ich hierher kam, Ray!"]
    },
    {
        es: ["¡Vivo aquí, sé cómo es la calle!"],
        de: ["Ich wohne hier, ich kenne die Straße!"]
    }
];
export default translations;